<script lang="ts" setup>
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { onBeforeMount, ref, watch } from "vue";
import { Tab, Tabs } from "vant";
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { useCoin } from "@/stores/coin";

const loading = ref(false);
const currentTab = ref(0);
const coin = useCoin();
const incomeListRef = ref<ThreadListInstance | null>(null);
const expenditureListRef = ref<ThreadListInstance | null>(null);

const refreshRecordsByTabIdx = async (idx: number) => {
  if (idx === 0) {
    coin.incomeList = [];
    incomeListRef.value?.resetScrollLoadingState();
  } else {
    coin.expenditureList = [];
    expenditureListRef.value?.resetScrollLoadingState();
  }
};
onBeforeMount(() => {
  refreshRecordsByTabIdx(currentTab.value);
});

watch(currentTab, (newVal) => {
  refreshRecordsByTabIdx(newVal);
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr_auto] relative story-home">
    <threads-nav :enable-switch-mate="false" show-back>
      <template #center> {{ $t("Coin.coinRecords") }}</template>
    </threads-nav>
    <div v-if="loading" class="flex items-center justify-center">
      <div class="loading"></div>
    </div>
    <div v-else class="overflow-hidden">
      <tabs
        v-model:active="currentTab"
        class="h-full grid grid-rows-[auto_1fr] thread-tabs"
        swipeable
      >
        <tab :title="$t('Coin.incomeRecord')" class="overflow-y-auto">
          <thread-list
            ref="incomeListRef"
            :on-pull-load="coin.fetchNewerIncomeList"
            :on-scroll-load="coin.fetchOlderIncomeList"
            class="px-2"
          >
            <coin-record-item
              v-for="item in coin.incomeList"
              :key="item.id"
              :amount="item.coinAmount"
              :taskType="item.entity?.coinQuestId"
              :time="item.dtCreate"
              :title="item.title"
              :type="item.type"
            />
          </thread-list>
        </tab>
        <tab :title="$t('Coin.expenditureRecord')" class="overflow-y-auto">
          <thread-list
            ref="expenditureListRef"
            :on-pull-load="coin.fetchNewerExpenditureList"
            :on-scroll-load="coin.fetchOlderExpenditureList"
            class="px-2"
          >
            <coin-record-item
              v-for="item in coin.expenditureList"
              :key="item.id"
              :amount="item.coinAmount"
              :time="item.dtCreate"
              :title="$t('Coin.buyTicket')"
              :type="item.type"
            />
          </thread-list>
        </tab>
      </tabs>
    </div>
  </div>
</template>
